import React, { Component } from 'react';
import { View, Button, Modal, Spinner, Card, PageContainer, Loc } from '../UIElements/All.js';
import { Colors, ButtonColors, ModalColors } from '../Managers/ThemeManager';

import { getUser, getRewards, getOneTimeRewards, getQualifiedDiscounts, refundTransaction, resendPortalLink, evaluateCheckIn, checkIn } from '../Managers/NetworkManager';
import { getTotalAmountOutstanding, close, getReceipt, voidPayment, addCheckIn, setPageTitles } from '../Managers/LSLoyaltyAPI';
import { push, registerListenerForAction, removeListenerForAction } from '../Managers/AppActions';
import { stringPhoneValue, isRetail, pts, isMobile } from '../Managers/Utils';
var LocalizationManager = require('../Managers/LocalizationManager.js');

export default class CustomerOptions extends Component 
{
  constructor(props) 
  {
    super(props);

    var state = this.props.location.state;
    state.isUpdating = true;
    state.showPay = state.qrCode.type != "phone" && state.qrCode.type != "GC";
    state.user = null;
    state.outstandingAmount = "";
    state.hasAddedPayment = !isRetail();
    state.rewards = [];
    state.receipt = null;
    state.oneTimeRewards = [];
    state.qualifiedDiscounts = [];
    state.showPortalButton = state.qrCode.type == "phone";
    state.possiblePoints = null;
    state.hasRedeemedReward = isRetail();
    state.hasEarnedPoints = isRetail();
    this.state = state;
  }

  componentDidMount()
  {
  	this.updateUser();
  	this.updateOutstandingAmount();
	LocalizationManager.localizedStringForKey("LOYALTY_OPTIONS_PAGE_TITLE", [], (retrievedString)=>
	{
		setPageTitles(null,retrievedString, "asdf");
	});  	
  	// update again later, because the invoice may have changed
  	var self = this;
  	if( !isRetail() )
  	{
	  	this.updateInterval = setInterval(()=>
	  	{
	  		self.updateOutstandingAmount();
	  	}, 1000)  		
  	}
  }

  componentWillUnmount()
  {
  	clearTimeout(this.updateInterval);
  }

  updateUser()
  {
  	var self = this;
  	getUser(this.state.qrCode.userID, this.state.qrCode.hash, this.state.urlInputs).then((user)=>
  	{
  		if( user == null || user.length == 0 )
  		{
  			push(self, 'invalidQRCode', {urlInputs:self.state.urlInputs});
  			return;
  		}

  		self.setUser(user);
  		self.setState({isUpdating:false})
	})
  }

  componentDidUpdate(prevProps, prevState)
  {
  	if( isRetail() ) return;

  	if( this.state.user != null )
  	{
  		this.checkIn();
		if( typeof window.hasAutoNavigated === 'undefined' || !window.hasAutoNavigated )
		{
			window.hasAutoNavigated = true;
			if( this.state.qrCode.isVoid ) this.voidSelected();
			else if( this.state.qrCode.type == "credit" ) this.paySelected();
			else if( this.state.qrCode.type == "reward" && typeof this.state.qrCode.rewardID !== "undefined" ) this.redeemRewardSelected();
		}
	}
  }

  updateRewards()
  {
  	getRewards(this.state.qrCode.userID, this.state.qrCode.hash, this.state.urlInputs).then((rewards)=> this.setState({rewards}))
  	getOneTimeRewards(this.state.user.UserID, this.state.user.Hash, this.state.urlInputs).then((oneTimeRewards)=> this.setState({oneTimeRewards}))
	getQualifiedDiscounts(this.state.qrCode.userID, this.state.qrCode.hash, this.state.qrCode.type, this.state.receipt, this.state.urlInputs).then((result, error)=> 
	{
		if( error == null )
		{
			this.setState({qualifiedDiscounts:result.QualifiedDiscounts, hasRedeemedReward:false, hasEarnedPoints:false})
		}
	})
  }

  updateOutstandingAmount()
  {
  	var self = this;
  	var urlInputs = this.state.urlInputs;
  	if( isRetail() )
  	{
  		evaluateCheckIn(this.state.qrCode.userID, this.state.qrCode.hash, this.state.urlInputs).then((response, error)=>
  		{
  			if( response != null && typeof response.PointsEarned !== 'undefined' )
  			{
  				self.setState(
				{
					possiblePoints:response.PointsEarned, 
					hasRedeemedReward:response.HasRedeemedReward, 
					hasEarnedPoints:response.HasEarnedPoints,
				}); 
  			}
  			else
  			{
  				if(error.code === -92){
					self._pageContainer.getModal().showAlert("ERROR_ALERT_TITLE", "PAY_EARN_CAMPAIGN_DISABLED_ERROR", ["BACK_TO_SALE_BUTTON"], [()=>{close(urlInputs)}]);
				}
				else
				{
					self._pageContainer.getModal().showAlert("SOMETHING_WENT_WRONG_ERROR_TITLE", "EVALUATE_CHECK_IN_ERROR_BODY", ["BACK_TO_SALE_BUTTON"], [()=>{close(urlInputs)}]);
				}
  			}
  		})
  	}
  	else
  	{
	  	getReceipt().then((receipt)=>
		{
			var outstandingAmount = parseFloat(receipt.totalDue).toFixed(2)
			self.setState({outstandingAmount, receipt, hasAddedPayment: receipt.hasAddedReUpPayment == "1", hasRedeemedReward: receipt.hasAddedReUpReward == "1"});
	  		if( typeof self.state.receipt === 'undefined' || receipt.totalDue != self.state.receipt.totalDue) self.updateRewards();

	  		self.checkIn();
		});  		
  	}
  }

  setUser(user)
  {
  	this.setState({user})
  }

  checkIn()
  {
  	if( isRetail() ) return;

  	if( this.state.user == null || this.state.receipt == null ) return;
  	
  	if( typeof this.hasCheckIn === 'undefined' || !this.hasCheckIn )
	{
		var payments = JSON.parse(this.state.receipt.payments);
		var hasCheckIn = this.state.receipt.hasAddedReUpCheckIn == "1";

		if( !hasCheckIn ) 
		{
			this.hasCheckIn = true;
			addCheckIn("NAME", this.state.qrCode.userID, this.state.qrCode.hash, this.state.qrCode.type)
		}
	}
  }

  redeemRewardSelected()
  {
  	var self = this;
	  if( this.state.hasRedeemedReward )
	  {
		self._pageContainer.getModal().showAlert("ERROR_ALERT_TITLE", "ONLY_ONE_REWARD_REDEMPTION_ERROR", ["OKAY_BUTTON"], [()=>{self._pageContainer.getModal().hide()}]);
	  } 
	  else if( this.state.hasAddedPayment )
	  {
		self._pageContainer.getModal().showAlert("ERROR_ALERT_TITLE", "REDEEM_REWARD_AFTER_PAYMENT_ALERT_BODY", ["OKAY_BUTTON"], [()=>{self._pageContainer.getModal().hide()}]);
	  } 
	  else if( this.state.hasEarnedPoints )
	  {
		self._pageContainer.getModal().showAlert("ERROR_ALERT_TITLE", "REDEEM_REWARD_AFTER_ASSIGNING_POINTS_ERROR", ["OKAY_BUTTON"], [()=>{self._pageContainer.getModal().hide()}]);
	  } 
  	else push(this, "redeemReward", {user:this.state.user, urlInputs:this.state.urlInputs, rewards:this.state.rewards, oneTimeRewards:this.state.oneTimeRewards, qualifiedDiscounts:this.state.qualifiedDiscounts, receipt:this.state.receipt, qrCode:this.state.qrCode, accountType:this.state.qrCode.type});
  }

  paySelected()
  {
  	var self = this;
	  if( this.state.hasAddedPayment )
	  {
		self._pageContainer.getModal().showAlert("ERROR_ALERT_TITLE", "ONE_APP_PAYMENT_PER_RECEIPT_ALERT_BODY", ["OKAY_BUTTON"], [()=>{self._pageContainer.getModal().hide()}]);
	  } 
  	else push(this, "addPayment", {user:this.state.user, outstandingAmount:this.state.outstandingAmount, qrCode:this.state.qrCode, accountType:this.state.qrCode.type});
  }

  voidSelected()
  {
  	var self = this;
	self._pageContainer.getModal().showAlert("VOID_PAYMENT_ALERT_TITLE", "VOID_PAYMENT_ALERT_BODY", ["NO_BUTTON", "VOID_BUTTON"], [()=>{close(this.state.urlInputs)}, ()=>
	{
		self._pageContainer.getModal().showSpinner("REFUND_TRANSACTION_SPINNER");
		var transactionID = self.state.qrCode.transactionID;
		refundTransaction(transactionID).then((a)=>
		{
			var uuid = self.state.qrCode.uuid;
			voidPayment(uuid).then(()=>
			{
				self.updateUser()
				self._pageContainer.getModal().hide()
			})
		})
	}]);
  }

  resendPortalLink()
  {
	var self = this;
	self._pageContainer.getModal().showSpinner("SENDING_PORTAL_LINK_SPINNER");
  	
  	resendPortalLink(self.state.user.UserID, self.state.user.Hash, this.state.urlInputs).then(()=>
  	{
  		self._pageContainer.getModal().hide();
  	})
  }

  retailCheckIn()
  {
	var self = this;
  	if( this.state.possiblePoints !== null && this.state.possiblePoints != 0 )
  	{
		self._pageContainer.getModal().showSpinner("ADDING_POINTS_SPINNER");

		checkIn(self.state.qrCode.userID, self.state.qrCode.hash, self.state.urlInputs).then((response)=>
		{
			self._pageContainer.getModal().hide();
			if( response == null )
			{
				self._pageContainer.getModal().showAlert("ERROR_ALERT_TITLE", "ADDING_POINTS_ERROR_BODY", ["OKAY_BUTTON"], [()=>{self._pageContainer.getModal().hide()}]);
			}
			else
			{
				self.state.user.Points = response.CurrentPoints;
				self.setState({user:self.state.user})
				
				if(response.PointsEarned > 0 )
				{
					self._pageContainer.getModal().showAlert("POINTS_ADDED_ALERT_TITLE", "POINTS_ADDED_ALERT_BODY", ["OKAY_BUTTON"], [()=>{self._pageContainer.getModal().hide(); close(self.state.urlInputs);}]);	
				}
				else
				{
					self._pageContainer.getModal().showAlert("POINTS_REMOVED_ALERT_TITLE", "POINTS_REMOVED_BODY_TITLE", ["OKAY_BUTTON"], [()=>{self._pageContainer.getModal().hide(); close(self.state.urlInputs);}]);	
				}
			}
		})
  	}
  	else
  	{
		self._pageContainer.getModal().showAlert("NO_POINTS_TO_ASSIGN_ALERT_TITLE", "NO_POINTS_TO_ASSIGN_ALERT_BODY", ["OKAY_BUTTON"], [()=>{self._pageContainer.getModal().hide()}]);
  	}
  }

  render()
  {
  	var self = this;

  	var fullName = null;
  	var phoneNumber = null;
  	var giftCardNumber = null;
  	var email = null;
  	if( this.state.user != null )
  	{
  		if( typeof this.state.user.PhoneNumber !== 'undefined' ) phoneNumber = stringPhoneValue(this.state.user.PhoneNumber);
  		if( typeof this.state.user.FirstName !== 'undefined' && typeof this.state.user.LastName !== 'undefined' ) fullName = this.state.user.FirstName + " " + this.state.user.LastName;
  		if( typeof this.state.user.Name !== 'undefined' ) fullName = this.state.user.Name;
  		if( this.state.qrCode.type == "GC" ) giftCardNumber = this.state.user.UserName;
  		else if( typeof this.state.user.UserName !== 'undefined' && this.state.user.UserName.includes("@") ) email = this.state.user.UserName;
  	}

  	var outstandingAmount = this.state.outstandingAmount;

    return (
      <PageContainer ref={(a) => { this._pageContainer = a; }} urlInputs={this.state.urlInputs} successTitle="CUSTOMER_ENROLLED_SUCCESS_TITLE" successBody="CUSTOMER_ENROLLED_SUCCESS_BODY">
	      	<Card title={"CUSTOMER_INFO_CARD_TITLE"} style={{alignItems:'stretch', alignSelf:'stretch', flexDirection:'column', justifyContent:'center'}}>
	      		<View style={{position:'relative', alignSelf:'stretch', flex:-1, height:this.state.urlInputs.mobile ? 100 : 220, borderRadius:5}}>
		      	{
		      		this.state.user == null ?
		      			<View style={{flex:1, alignSelf:'stretch', color:Colors.text1, justifyContent:'center', alignItems:'center'}}>

		      			</View>
		      		:
		      			<View style={{flex:1, alignSelf:'stretch', flexDirection:'row'}}>
		      				<View style={{flex:1, alignSelf:'center', color:Colors.text1, justifyContent:'space-around', alignItems:'center', flexDirection:'column', fontSize:18}}>
				      			<View style={{margin:10, flex:-1, alignSelf:'stretch', flexDirection:'column', alignItems:'stretch'}}>
				      			{
				      				fullName != null ?
				      					<View style={{flex:-1, margin:12, justifyContent:'center'}}>
				      					{fullName}
				      					</View>
				      				: null
				      			}
				      			{
				      				giftCardNumber != null ?
				      					<View style={{flex:-1, margin:4, justifyContent:'center', flexDirection:'row'}}>
						      				<View style={{flex:1, marginRight:4, color:Colors.label2}}>
												<Loc locKey="GC_NUMBER_LABEL"></Loc>	
						      				</View>
						      				<View style={{flex:1}}>
						      					{giftCardNumber}
						      				</View>
				      					</View>
				      				: null
				      			}
				      			{
				      				phoneNumber != null ?
				      					<View style={{flex:-1, margin:4, justifyContent:'center', flexDirection:'row'}}>
				      						<View />
						      				<View style={{flex:-1, marginRight:4, color:Colors.label2}}>
											  <Loc locKey="PHONE_NUMBER_LABEL"></Loc>	
						      				</View>
						      				<View style={{flex:-1}}>
						      					{phoneNumber}
						      				</View>
						      				<View />
				      					</View>
				      				: null
				      			}
				      			{
				      				email != null ?
				      					<View style={{flex:-1, margin:4, justifyContent:'center', flexDirection:'row'}}>
				      						<View />
						      				<View style={{flex:-1, marginRight:4, color:Colors.label2}}>
												<Loc locKey="EMAIL_LABEL"></Loc>	
						      				</View>
						      				<View style={{flex:-1}}>
						      					{email}
						      				</View>
						      				<View />
				      					</View>
				      				: null
				      			}
				      			</View>
				      		</View>
				      		<View style={{alignSelf:'stretch', backgroundColor:Colors.border1, width:1, flex:-1}} />
				      		<View style={{flex:1, alignSelf:'center', color:Colors.text1, justifyContent:'space-around', alignItems:'center', flexDirection:'column', fontSize:18}}>
				      			
				      			{
				      				isRetail() ?
				      					<View style={{flex:-1, margin:10, flexDirection:'column'}}>
						      				<View style={{flex:-1, margin:4, alignItems:'center', flexDirection:'column'}}>
							      				<View style={{flex:1, fontSize:44}}>
							      					{this.state.user.Points}
							      				</View>
							      				<View style={{flex:1, fontSize:14, marginTop:4, color:Colors.label1}}>
													<Loc locKey="POINTS_CAPITALS_CONTEXTUAL" locParams={[this.state.user.Points]}></Loc>
							      				</View>
					      					</View>
						      			</View>
				      				: null
				      			}

				      			{
				      				!isRetail() ?
				      					<View style={{flex:-1, margin:10, flexDirection:'column'}}>
						      				{
						      					this.state.showPay ?
						      						<View style={{flex:-1, margin:4}}>
							      						<View style={{flex:1, marginRight:4, color:Colors.label1}}>
													<Loc locKey="CREDIT_LABEL" locParams={[this.state.user.Points]}></Loc>
									      				</View>
									      				<View style={{flex:1}}>
									      					{this.state.user.Credit}
									      				</View>
							      					</View>
								      			: null
						      				}				      				
							      			<View style={{flex:-1, margin:4}}>
							      				<View style={{flex:1, marginRight:4, color:Colors.label1}}>
													<Loc locKey="POINTS_LABEL" locParams={[this.state.user.Points]}></Loc>
							      				</View>
							      				<View style={{flex:1}}>
							      					{this.state.user.Points}
							      				</View>
					      					</View>
						      			</View>
				      				: null
				      			}
				      			{
				      				!isRetail() ?
				      					<View style={{flex:-1, margin:10, flexDirection:'column'}}>
						      				<View style={{flex:-1, margin:4, alignItems:'center'}}>
							      				<View style={{flex:1, marginRight:4, color:Colors.label1}}>
												  <Loc locKey="OUTSTANDING_LABEL" locParams={[this.state.user.Points]}></Loc>
							      				</View>
							      				<View style={{flex:1, fontSize:24}}>
							      					{outstandingAmount}
							      				</View>
					      					</View>
						      			</View>
				      				: null
				      			}

		      				</View>
		      			</View>
		      	}
		      	{
		      		this.state.isUpdating ?
		      			<View style={{position:'absolute', top:0, left:0, bottom:0, right:0, alignSelf:'stretch', color:Colors.text1, justifyContent:'center', alignItems:'center', backgroundColor:Colors.background2LoadingBackground}}>
		      				<Spinner color={ModalColors.border} />
		      			</View>
		      		: null
		      	}
		      	</View>
		     </Card>
		     <Card title="LOYALTY_OPTIONS_PAGE_TITLE" style={{marginTop:20}}>
		      	<Button onPress={()=> this.redeemRewardSelected()} enabled={!this.state.hasRedeemedReward && !this.state.hasAddedPayment && !this.state.hasEarnedPoints} type={0} colors={ButtonColors} style={{alignSelf:'stretch', margin:12, width:-1, alignItems:'center', justifyContent:'center'}}>
		      	{
      				this.state.possiblePoints === null ? 
      					<Spinner color={ModalColors.border} />
					  :
					  <Loc locKey="REDEEM_REWARD_BUTTON"></Loc>
      			}
		      	</Button>

		      	{
		      		isRetail() && false ?
		      			<Button onPress={()=> this.retailCheckIn()} enabled={this.state.possiblePoints !== null && this.state.possiblePoints != 0} type={0} colors={ButtonColors} style={{alignSelf:'stretch', margin:12, width:-1, alignItems:'center', justifyContent:'center'}}>
		      			{
		      				this.state.possiblePoints === null ? 
		      					<Spinner color={ModalColors.border} />
							  :
							  <Loc locKey="ASSIGN_POINTS_BUTTON" locParams={[this.state.possiblePoints]}></Loc>
		      			}
				      	</Button>
		      		: null
		      	}

		      	{
		      		this.props.showCollectPoints ?
		      			<Button onPress={()=> push("")} type={0} colors={ButtonColors} style={{alignSelf:'stretch', margin:12, width:-1}}>
						  <Loc locKey="COLLECT_POINTS_BUTTON"></Loc>
				      	</Button>
		      		: null
		      	}

		      	{
		      		this.state.showPay ?
				      	<Button onPress={()=> this.paySelected()} enabled={!this.state.hasAddedPayment} type={0} colors={ButtonColors} style={{alignSelf:'stretch', margin:12, width:-1}}>
						  <Loc locKey="PAY_WITH_APP_BUTTON"></Loc>
				      	</Button>
		      		: null
		      	}

		      	{
		      		this.state.showPortalButton ?
		      			<Button onPress={()=> self.resendPortalLink()} type={isRetail() ? 1 : 0} colors={ButtonColors} style={{alignSelf:'stretch', margin:12, width:-1}}>
						  <Loc locKey="RESEND_PORTAL_LINK_BUTTON"></Loc>						  
				      	</Button>
		      		: null
		      	}

		      	{
		      		!isRetail() ?
		      			<Button onPress={()=> close(this.state.urlInputs)} type={0} colors={ButtonColors} style={{alignSelf:'stretch', margin:12, width:-1}}>
							<Loc locKey="COLLECT_POINTS_BUTTON"></Loc>
				      	</Button>
		      		: null
		      	}
		      	
	      	</Card>
      </PageContainer>
    );
  }
}

CustomerOptions.defaultProps = {
	showCollectPoints: false
}
